export default __webpack_public_path__ + "static/media/mag2.4bb5ea1b.svg";